// extracted by mini-css-extract-plugin
module.exports = {"tabDesktop":"bW8exs","active":"ukbDhY","tabName":"Z1vG1z","closerWrapper":"Psp_AM","closer":"_0kgMpQ","tabMobile":"jXUnp3","iconMobile":"_1bXhyB","tabNameMobile":"MGLq81"};